import { MoneyScaled, removeScaleFromMoney } from '@quickbit/qb-design-system';

export const formatCurrency = (money: MoneyScaled) =>
  `${removeScaleFromMoney(money).toString()} ${money.currencyCode}`;
